<template>
  <BaseModal
    :value="true"
    :modal-title="$t('organization.createOrganization')"
    @close="reset"
  >
    <template #modal>
      <div class="d-flex flex-column">
        <BaseTextField
          v-model="form.organizationName"
          autofocus
          :label="`${$t('campaign.welcome.createPmoModal.nameLabel')} *`"
          :has-error="!!organizationNameErrors"
          :error-messages="organizationNameErrors"
          @change="$v.form.organizationName.$touch()"
        />
        <div class="d-flex align-items-center">
          <input v-model="form.isOrgaTest" type="checkbox" class="mr-2" />
          <label
            for="checkbox"
            @click.stop="form.isOrgaTest = !form.isOrgaTest"
          >
            {{ $t("organization.isOrganizationTest") }}</label
          >
        </div>
      </div>
    </template>
    <template #actions>
      <BaseButton
        text
        class="mx-2 ml-auto"
        type="secondary"
        color="#707080"
        :disabled="isSubmitting"
        @click="reset"
      >
        {{ $t("utils.cancel") }}
      </BaseButton>
      <BaseButton type="primary" :loading="isSubmitting" @click.stop="submit">
        {{ $t("folder.statusForm.validate") }}
      </BaseButton>
    </template>
  </BaseModal>
</template>
<script>
import { postCreateOrganization } from "@/core/Services/organization.service";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import { mapState } from "vuex/dist/vuex.common.js";
export default {
  name: "OrganizationCreateDialog",
  mixins: [validationMixin],
  data() {
    return {
      isSubmitting: false,
      form: {
        organizationName: "",
        isOrgaTest: false,
      },
    };
  },

  computed: {
    organizationNameErrors() {
      if (!this.$v.form.organizationName.$dirty) return "";
      if (!this.$v.form.organizationName.required)
        return this.$t("organization.organizationNameRequired");
      return "";
    },
    ...mapState({
      organizations: (state) => state.organization.organizations,
      user: (state) => state.account.user,
    }),
  },
  validations: {
    form: {
      organizationName: {
        required,
      },
    },
  },
  methods: {
    reset() {
      this.$emit("close");
      this.$v.$reset();
      this.form = {
        organizationName: "",
        isOrgaTest: false,
      };
    },
    async submit() {
      this.$v.form.$touch();
      if (this.$v.$invalid) {
        return;
      }
      this.isSubmitting = true;
      // Simulate API call
      try {
        const res = await postCreateOrganization({
          name: this.form.organizationName,
          for_test: this.form.isOrgaTest,
        });
        await this.$store.dispatch("account/refreshUser");
        this.$store.commit("organization/setOrganizations", [
          ...this.organizations,
          res,
        ]);

        this.$store.dispatch("snackbar/active", {
          message: this.$t("organization.organizationCreatedSuccessfully"),
          type: "SUCCESS",
        });
        this.$router.push({
          name: "ORGANIZATION_DASHBOARD",
          params: { organizationId: res.id },
        });
      } catch {
        this.$store.dispatch("snackbar/active", {
          message: this.$t("utils.errorHasHappen"),
          type: "ERROR",
        });
      }
      this.isSubmitting = false;
      this.reset();
    },
  },
};
</script>
<style lang="scss" scoped>
label {
  font-size: 14px;
}
input[type="checkbox"] {
  accent-color: #2536cc;
}
label[for="checkbox"] {
  cursor: pointer;
}
</style>
